import { Stack } from "@mui/material";
import { ModalData, PropertyModal } from "../PropertyModal/PropertyModal";
import { type ReactNode, useRef, useState } from "react";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { ScoreDetailChartBox } from "../Chart";
import type { ComponentAppearance } from "src/components/appearance";

export type ChartMode = "comparison" | "distribution" | "evolution";

type DimensionTreeSwitchProps = {
    distributionContent?: ReactNode;
    mode: ChartMode;
    appearance?: ComponentAppearance;
};
export const DimensionTreeSwitch = (props: DimensionTreeSwitchProps) => {
    const { distributionContent, mode, appearance = "legacy" } = props;
    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const propertyRef = useRef<ModalData | null>(null);

    const {
        score,
        olapScores,
        olapPrevScores,
        scoresParams,
        areAggregationsRequested,
        fetchPostForAnswers,
        hideSeeMoreDetails,
        getDimensionValueLocalizedLabel,
        getDimensionValuesColors,
        getDimensionValueDrilldownAction,
        isLoading,
        ssqVersion,
        prevCampaignLabel,
    } = useScoreDetailContext();

    const openModal = (property: ModalData) => {
        propertyRef.current = property;
        setModalOpen(true);
    };

    return (
        <Stack>
            <PropertyModal isOpen={isModalOpen} setOpen={setModalOpen} property={propertyRef.current} />

            <ScoreDetailChartBox
                scoreId={score.id}
                olapScores={olapScores}
                olapPrevScores={olapPrevScores}
                scoresParams={scoresParams}
                areAggregationsRequested={areAggregationsRequested}
                getDimensionValueLocalizedLabel={getDimensionValueLocalizedLabel}
                getDimensionValuesColors={getDimensionValuesColors}
                getDimensionValueDrilldownAction={getDimensionValueDrilldownAction}
                isLoading={isLoading}
                ssqVersion={ssqVersion}
                mode={mode}
                distributionContent={distributionContent}
                fetchPostForAnswers={fetchPostForAnswers}
                hideSeeMoreDetails={hideSeeMoreDetails}
                openModal={openModal}
                prevCampaign={prevCampaignLabel}
                appearance={appearance}
            />
        </Stack>
    );
};
